import { Component, Input } from '@angular/core';
import { SidenavSection, Tabs } from 'src/app/models/types/Tabs.type';
import { SharedModule } from 'src/app/modules/shared.module';

@Component({
  selector: 'app-sidenav-section',
  imports: [SharedModule],
  templateUrl: './sidenav-section.component.html',
  styleUrl: './sidenav-section.component.scss'
})
export class SidenavSectionComponent {

  @Input('section') section!: SidenavSection;

  constructor() { }

}
